.panel {
  border: 1px solid var(--border-strong);
  border-radius: 0.375rem;
  background: var(--surface-raised);
  padding: 0.5rem 0.75rem;
}

.title {
  margin: 0 0 0.5rem;
  font-size: 1rem;
}

.empty {
  margin: 0;
  color: var(--text-muted);
}

.list {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  max-height: 12rem;
  margin: 0;
  padding: 0;
  overflow: auto;
  list-style: none;
}

.item {
  font-family: monospace;
  font-size: 0.875rem;
}

.level {
  font-weight: 600;
}

.kind {
  color: var(--text-muted);
}

.text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
